import { gql } from '@apollo/client';

export const MUTATION_INSERT_USER_TO_DEVICE = gql`
  mutation MUTATION_INSERT_USER_TO_DEVICE(
    $userToDevices: [userToDevices_insert_input!]!
  ) {
    insert_userToDevices(objects: $userToDevices) {
      affected_rows
      returning {
        created_at
        description
        deviceId
        doctorId
        id
        updated_at
        userId
      }
    }
  }
`

export const MUTATION_UPDATE_USER_TO_DEVICE_BY_DEVICE_ID = gql`
  mutation MUTATION_UPDATE_USER_TO_DEVICE_BY_DEVICE_ID(
    $userToDeviceUpdated: userToDevices_set_input!, 
    $deviceId: String!
  ) {
    update_userToDevices(_set: $userToDeviceUpdated, where: {deviceId: {_eq: $deviceId}}) {
      affected_rows
      returning {
        created_at
        description
        deviceId
        doctorId
        id
        updated_at
        userId
      }
    }
  }
`

export const MUTATION_DELETE_USER_TO_DEVICE_BY_DEVICE_ID = gql`
  mutation MUTATION_DELETE_USER_TO_DEVICE_BY_DEVICE_ID(
    $deviceId: [String!]!
  ) {
    delete_userToDevices(where: {deviceId: {_in: $deviceId}}) {
      affected_rows
      returning {
        created_at
        description
        deviceId
        doctorId
        id
        updated_at
        userId
      }
    }
  }
`